import { FC, useState } from 'react';
import WhatsappDocuments from './WhatsappDocuments';
import { Modal } from 'react-bootstrap';
import { useAuth } from '../../../../../auth';
import { useLocation } from 'react-router-dom';
import { generateAddress } from '../../../../../../../_metronic/helpers';


interface UserTableModalProps {
    user: any;
    onClose: () => void;
    show: boolean;
}

export const TextilePopUp: FC<UserTableModalProps> = ({ user, onClose, show }) => {
    console.log("usssss", user);


    const location = useLocation();
    const currentPath = location.pathname;
    const shouldHide =
        currentPath.includes('apps/sales/supply-orders') ||
        currentPath.includes('apps/purchase/supply-orders') ||
        currentPath.includes('apps/finance/supply-orders2') ||
        currentPath.includes('apps/logic/supply-orders');




    const shouldHide2 =
        currentPath.includes('apps/sales/reconcillation') ||
        currentPath.includes('apps/finance/payment') ||
        currentPath.includes('apps/purchase/reconcillation') ||
        currentPath.includes('apps/purchase/PayablesPurchaseAdmin') ||
        currentPath.includes('apps/logic/payables') ||
        currentPath.includes('apps/finance/payablesFinance') ||
        currentPath.includes('apps/transactions/quality-assessment') ||
        currentPath.includes('apps/transactions/payment-recycler')




    const { currentUser } = useAuth()
    const userType = (currentUser as any).userType;

    const [selectedDocs, setSelectedDocs] = useState<any[]>([]);

    const handleDocToggle = (docUrl: string, docType: string) => {
        const isSelected = selectedDocs.some(d => d.docUrl === docUrl);
        if (isSelected) {
            setSelectedDocs(selectedDocs.filter(d => d.docUrl !== docUrl));
        } else {
            setSelectedDocs([...selectedDocs, { docUrl, docType }]);
        }
    };

    return (
        <Modal
            className='modal fade'
            id='kt_modal_view_user'
            data-backdrop='static'
            tabIndex={-1}
            role='dialog'
            show={show}
            centered
            size="lg"
        >
            <div className="modal-content">
                <div className="modal-header pb-0 border-0 justify-content-end">
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={onClose}> X
                    </div>
                </div>

                <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
                    <div className="text-center mb-13">
                        <h3 className="mb-3" style={{ fontWeight: 600, fontSize: "17.55px" }}>View Order Details</h3>
                    </div>



                    {/* <table style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                        marginBottom: '20px',
                        tableLayout: 'fixed'
                    }}>
                        <thead>
                            <tr>
                                <th style={{
                                    width: '50%',
                                    backgroundColor: "#BFD7ED",
                                    color: "black",
                                    fontWeight: "bold",
                                    padding: "12px",
                                    textAlign: "center",
                                    border: "1px solid #ddd"
                                }}>
                                    Purchase Order Id
                                </th>
                                <th style={{
                                    width: '50%',
                                    backgroundColor: "#BFD7ED",
                                    color: "black",
                                    fontWeight: "bold",
                                    padding: "12px",
                                    textAlign: "center",
                                    border: "1px solid #ddd"
                                }}>
                                    Sale Order Id
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{ padding: '10px', textAlign: 'center', border: '1px solid #ddd' }}>
                                    {user?.transactionId}
                                </td>
                                <td style={{ padding: '10px', textAlign: 'center', border: '1px solid #ddd' }}>
                                    {user?.displaySaleOrderId}
                                </td>
                            </tr>
                        </tbody>
                    </table> */}


                    {!shouldHide2 && (
                        <>
                            <table style={{
                                width: '100%',
                                borderCollapse: 'collapse',
                                marginBottom: '20px',
                                tableLayout: 'fixed' // This helps maintain consistent column widths
                            }}>
                                <thead style={{ backgroundColor: '#BFD7ED' }}>
                                    <tr>
                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Supplier Information</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                            <div style={{ fontWeight: '' }}>Purchase Order Id </div>
                                            <div style={{ marginTop: '4px', color: '#666' }}>{user?.transactionId || 'N/A'}</div>

                                        </td>
                                    </tr>
                                    <tr>

                                        <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                            <div style={{ fontWeight: '' }}>{user.sellerInfo?.sellerName || 'N/A'}</div>
                                            <div style={{ marginTop: '4px', color: '#666' }}>{generateAddress(user?.sellerInfo?.address) || 'N/A'}</div>



                                        </td>

                                    </tr>
                                    <tr>
                                        <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                            <div style={{ fontWeight: '' }}>GST Number </div>
                                            <div style={{ marginTop: '4px', color: '#666' }}>{user.sellerInfo?.gstNumber || 'N/A'}</div>

                                        </td>
                                    </tr>

                                </tbody>
                            </table>

                            {/* <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                                <thead >
                                    <tr className="fw-bold text-muted bg-light">
                                        <th className="min-w-100px ps-4" style={{ backgroundColor: '#BFD7ED', color: "black" }}> Category</th>
                                        <th className="min-w-100px" style={{ backgroundColor: '#BFD7ED', color: "black" }}>Item</th>
                                        <th className="min-w-100px" style={{ backgroundColor: '#BFD7ED', color: "black" }}>Grade</th>
                                        <th className="min-w-100px" style={{ backgroundColor: '#BFD7ED', color: "black" }}>Color</th>
                                        <th className="min-w-100px" style={{ backgroundColor: '#BFD7ED', color: "black" }}>Packaging</th>
                                        <th className="min-w-100px" style={{ backgroundColor: '#BFD7ED', color: "black" }}>Quantity</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="ps-4">
                                            <span className="text-dark fw-semibold d-block fs-6">
                                                {user?.orderDetail?.[0]?.categoryName || 'N/A'}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="text-dark fw-semibold d-block fs-6">
                                                {user?.orderDetail?.[0]?.items?.[0].itemName || 'N/A'}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="text-dark fw-semibold d-block fs-6">
                                                {user?.orderDetail?.[0]?.items?.[0].grade || 'N/A'}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="text-dark fw-semibold d-block fs-6">
                                                {user?.orderDetail?.[0]?.items?.[0].color || 'N/A'}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="text-dark fw-semibold d-block fs-6">
                                                {user?.orderDetail?.[0]?.items?.[0].packagingType || 'N/A'}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="text-dark fw-semibold d-block fs-6">
                                                {user?.orderDetail?.[0]?.items?.[0].quantity || 'N/A'} Kg
                                            </span>
                                        </td>

                                    </tr>
                                </tbody>
                            </table> */}

                            <div className="table-responsive">
                                <table style={{
                                    width: "100%",
                                    borderCollapse: "collapse",
                                    marginBottom: "20px",
                                    border: "1px solid #ddd"
                                }}>
                                    <thead>
                                        <tr>
                                            <th

                                                style={{
                                                    backgroundColor: "#BFD7ED",
                                                    color: "black",
                                                    fontWeight: "bold",
                                                    padding: "12px",
                                                    textAlign: "left",
                                                    border: "1px solid #ddd"
                                                }}>
                                                Order Details
                                            </th>
                                            <th

                                                style={{
                                                    backgroundColor: "#BFD7ED",
                                                    color: "black",
                                                    fontWeight: "bold",
                                                    padding: "12px",
                                                    textAlign: "left",
                                                    border: "1px solid #ddd"
                                                }}>
                                                Sales Order
                                            </th>
                                            <th

                                                style={{
                                                    backgroundColor: "#BFD7ED",
                                                    color: "black",
                                                    fontWeight: "bold",
                                                    padding: "12px",
                                                    textAlign: "left",
                                                    border: "1px solid #ddd"
                                                }}>
                                                Purchase Order
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td style={{
                                                width: "33%",
                                                padding: "10px",
                                                textAlign: "left",
                                                border: "1px solid #ddd",
                                                fontWeight: "bold"
                                            }}>
                                                Category
                                            </td>
                                            <td style={{
                                                padding: "10px",
                                                textAlign: "left",
                                                border: "1px solid #ddd"
                                            }}>
                                                {user?.materialInfo?.categoryName || 'N/A'}
                                            </td>
                                            <td style={{
                                                padding: "10px",
                                                textAlign: "left",
                                                border: "1px solid #ddd"
                                            }}>
                                                {user?.materialInfo?.categoryName || 'N/A'}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{
                                                fontWeight: "bold",
                                                padding: "10px",
                                                textAlign: "left",
                                                border: "1px solid #ddd"
                                            }}>
                                                Item
                                            </td>
                                            <td style={{
                                                padding: "10px",
                                                textAlign: "left",
                                                border: "1px solid #ddd"
                                            }}>
                                                {user?.materialInfo?.materialName || 'N/A'}
                                            </td>
                                            <td style={{
                                                padding: "10px",
                                                textAlign: "left",
                                                border: "1px solid #ddd"
                                            }}>
                                                {user?.materialInfo?.materialName || 'N/A'}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{
                                                fontWeight: "bold",
                                                padding: "10px",
                                                textAlign: "left",
                                                border: "1px solid #ddd"
                                            }}>
                                                Grade
                                            </td>
                                            <td style={{
                                                padding: "10px",
                                                textAlign: "left",
                                                border: "1px solid #ddd"
                                            }}>
                                                {user?.materialInfo?.grade || 'N/A'}
                                            </td>
                                            <td style={{
                                                padding: "10px",
                                                textAlign: "left",
                                                border: "1px solid #ddd"
                                            }}>
                                                {user?.materialInfo?.grade || 'N/A'}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{
                                                fontWeight: "bold",
                                                padding: "10px",
                                                textAlign: "left",
                                                border: "1px solid #ddd"
                                            }}>
                                                Quantity ({user?.quantityInfo?.unit})
                                            </td>
                                            <td style={{
                                                padding: "10px",
                                                textAlign: "left",
                                                border: "1px solid #ddd"
                                            }}>
                                                {user?.quantityInfo?.quantity || 'N/A'}
                                            </td>
                                            <td style={{
                                                padding: "10px",
                                                textAlign: "left",
                                                border: "1px solid #ddd"
                                            }}>
                                                <span className='px-2 py-1' style={{ fontSize: '13px' }}>{user?.quantityInfo?.quantity || 'N/A'} </span> {user?.verifiedPurchasePriceInfo?.quantity && <span className='badge badge-light-success px-2 py-1' style={{ fontSize: '13px' }}>{user?.verifiedPurchasePriceInfo?.quantity || ''}</span>}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{
                                                fontWeight: "bold",
                                                padding: "10px",
                                                textAlign: "left",
                                                border: "1px solid #ddd"
                                            }}>
                                                Price (INR/Kgs)
                                            </td>
                                            <td style={{
                                                padding: "10px",
                                                textAlign: "left",
                                                border: "1px solid #ddd"
                                            }}>
                                                {user?.confirmSaleOrderPrice || 'N/A'}
                                            </td>
                                            <td style={{
                                                padding: "10px",
                                                textAlign: "left",
                                                border: "1px solid #ddd"
                                            }}>
                                                <span className='px-2 py-1' style={{ fontSize: '13px' }}>{user?.purchasePriceInfo?.pricePerUnit || 'N/A'}</span> <span className='badge badge-light-success px-2 py-1' style={{ fontSize: '13px' }}>{user?.verifiedPurchasePriceInfo?.pricePerUnit || ''}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>


                        </>)}




                    {!shouldHide && (
                        <>
                            <table style={{
                                width: '100%',
                                borderCollapse: 'collapse',
                                marginBottom: '20px',
                                tableLayout: 'fixed' // This helps maintain consistent column widths
                            }}>
                                <thead style={{ backgroundColor: '#BFD7ED' }}>
                                    <tr>
                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Buyer Information</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                            <div style={{ fontWeight: '' }}>Sale Order Id </div>
                                            <div style={{ marginTop: '4px', color: '#666' }}>  {user?.displaySaleOrderId || "NA"}</div>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                            <div style={{ fontWeight: '' }}>{user.buyerInfo?.buyerName || 'N/A'}</div>
                                            <div style={{ marginTop: '4px', color: '#666' }}>{generateAddress(user.buyerInfo?.address?.[0]) || 'N/A'}</div>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                            <div style={{ fontWeight: '' }}>GST Number </div>
                                            <div style={{ marginTop: '4px', color: '#666' }}>{user.buyerInfo?.gstNumber || 'N/A'}</div>

                                        </td>
                                    </tr>

                                </tbody>
                            </table>

                            {/* <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                                <thead style={{ backgroundColor: '#BFD7ED' }}>
                                    <tr>
                                        <th style={{ fontWeight: "bold", paddingLeft: "10px" }}>Category</th>
                                        <th style={{ fontWeight: "bold" }}>Item</th>
                                        <th style={{ fontWeight: "bold" }}>Grade</th>
                                        <th style={{ fontWeight: "bold" }}>Color</th>
                                        <th style={{ fontWeight: "bold" }}>Packaging</th>
                                        <th style={{ fontWeight: "bold" }}>Quantity</th>
                                    </tr>
                                </thead>
                                <tbody >
                                    {user?.dispatchOrderDetail?.map((order: any, index: number) => (
                                        order.items.map((item: any, itemIndex: number) => (
                                            <tr key={`${index}-${itemIndex}`}>
                                                <td>{order.categoryName || 'N/A'}</td>
                                                <td>{item.itemName || 'N/A'}</td>
                                                <td>{item.grade || 'N/A'}</td>
                                                <td>{item.color || 'N/A'}</td>
                                                <td>{item.packagingType || 'N/A'}</td>
                                                <td>{item.quantity || 'N/A'} Kg</td>
                                            </tr>
                                        ))
                                    )) || (
                                            <tr>
                                                <td colSpan={6} className="text-center">No Items Found</td>
                                            </tr>
                                        )}
                                </tbody>
                            </table> */}




                            {/* <table style={{
                                width: '100%',
                                borderCollapse: 'collapse',
                                marginBottom: '20px',
                                tableLayout: 'fixed'
                            }}>
                                <thead style={{ backgroundColor: '#BFD7ED' }}>
                                    <tr>
                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Unit Price</th>
                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Total Amount</th>
                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Tax Structure</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                            <span className="text-dark fw-semibold d-block fs-6">
                                                {user?.pricePaymentInfo?.pricePerUnit || 'N/A'}
                                            </span>
                                        </td>
                                        <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                            <span className="text-dark fw-semibold d-block fs-6">
                                                {user?.pricePaymentInfo?.totalAmount || 'N/A'}
                                            </span>
                                        </td>
                                        <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                            <span className="text-dark fw-semibold d-block fs-6">
                                                {user?.pfcGstInfo?.gstType || 'N/A'} ({user?.pfcGstInfo?.gstPercentage || 0}%)
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table> */}

                            {/* Second Table with Color, Grade, Packaging */}
                            {/* <table style={{
                                width: '100%',
                                borderCollapse: 'collapse',
                                marginBottom: '20px',
                                tableLayout: 'fixed' // This helps maintain consistent column widths
                            }}>
                                <thead style={{ backgroundColor: '#BFD7ED' }}>
                                    <tr>
                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Color</th>
                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Grade</th>
                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Packaging</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {user?.dispatchOrderDetail?.map((order: any, index: number) => (
                                        order.items.map((item: any, itemIndex: number) => (
                                            <tr key={`second-${index}-${itemIndex}`}>
                                                <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{item.color || 'N/A'}</td>
                                                <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{item.grade || 'N/A'}</td>
                                                <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{item.packagingType || 'N/A'}</td>
                                            </tr>
                                        ))
                                    )) || (
                                            <tr>
                                                <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>No Items Found</td>
                                            </tr>
                                        )}
                                </tbody>
                            </table> */}

                            {/* <div className="text-center mb-13">
                                <h1 className="mb-3 text-start">Invoice Information</h1>
                            </div>
                            <div className="d-flex flex-wrap gap-3">
                                {user?.dispatchImages?.filter(img => img.docType === "PFC_INVOICE").length > 0 ? (
                                    user?.dispatchImages
                                        .filter(img => img.docType === "PFC_INVOICE")
                                        .map((img, index) => (
                                            <div key={index} className="text-center">
                                                <img
                                                    src={img.docUrl}
                                                    alt={`Invoice ${index + 1}`}
                                                    className="h-150px w-150px object-cover rounded cursor-pointer"
                                                    style={{ maxWidth: '300px', border: '1px solid #eee' }}
                                                    onClick={() => window.open(img.docUrl, '_blank')}
                                                    onError={(e) => {
                                                        e.currentTarget.src = '/media/avatars/blank.png';
                                                    }}
                                                />
                                            </div>
                                        ))
                                ) : (
                                    <span className="text-dark fw-semibold d-block fs-6">N/A</span>
                                )}
                            </div> */}

                        </>)}









                    <div className="table-responsive">
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            marginBottom: '20px',
                            tableLayout: 'fixed'
                        }}>
                            <thead>
                                <tr className="fw-bold bg-light">
                                    <th className="min-w-100px" style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Approved By</th>
                                    <th className="min-w-100px" style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Date</th>
                                    <th className="min-w-100px" style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Remarks</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user?.financeApproval?.approvedByName || 'N/A'}
                                        </span>
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user?.financeApproval?.approvedAt?.split('T')[0] || 'N/A'}
                                        </span>
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user?.financeApproval?.remark || 'N/A'}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>










                    {/* <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">

                        <thead style={{ backgroundColor: '#BFD7ED' }}>
                            <tr className="fw-bold" style={{
                                paddingLeft:"10px"
                            }}>
                                <th>Address</th>
                            </tr>
                        </thead>
                        <tbody>

                            <tr>
                                <td>{user.deliveryAddress || 'N/A'}</td>
                            </tr>

                        </tbody>

                    </table> */}



















                    <div className="table-responsive">
                        <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                            <thead>
                                <tr className="fw-bold text-muted bg-light">
                                    <th className="min-w-100px" style={{ backgroundColor: '#bfd7ed', color: 'black', paddingLeft: "10px" }}>Purchase Order</th>
                                    <th className="min-w-100px" style={{ backgroundColor: '#bfd7ed', color: 'black', paddingLeft: "10px" }}>Transporter Information</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="d-flex gap-4 flex-wrap">
                                            {user.financeApproval?.purchaseOrderUrls?.length > 0 ? (
                                                user.financeApproval.purchaseOrderUrls.map((url: string, index: number) => {
                                                    const isPdf = url.toLowerCase().endsWith('.pdf') || url.toLowerCase().includes('.pdf')

                                                    return (
                                                        <div key={index} className="text-center" style={{ position: 'relative' }}>
                                                            <div style={{ position: 'absolute', top: '5px', left: '5px', zIndex: 10 }}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selectedDocs.some(d => d.docUrl === url)}
                                                                    onChange={() => handleDocToggle(url, 'Purchase Order')}
                                                                    style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                                                                />
                                                            </div>
                                                            {isPdf ? (
                                                                <div
                                                                    className="d-flex flex-column align-items-center justify-content-center rounded cursor-pointer"
                                                                    style={{
                                                                        width: '140px',
                                                                        height: '150px',
                                                                        border: '1px solid #eee',
                                                                        backgroundColor: '#f8f9fa'
                                                                    }}
                                                                    onClick={() => window.open(url, '_blank')}
                                                                >
                                                                    <i
                                                                        className="bi bi-file-earmark-pdf-fill"
                                                                        style={{ fontSize: '50px', color: '#dc3545' }}
                                                                    ></i>
                                                                    <span className="mt-2 text-muted" style={{ fontSize: '12px' }}>View PDF</span>
                                                                </div>
                                                            ) : (
                                                                <img
                                                                    src={url}
                                                                    alt={`Purchase Order ${index + 1}`}
                                                                    className="h-150px w-150px object-cover rounded cursor-pointer"
                                                                    style={{ maxWidth: '140px', border: '1px solid #eee' }}
                                                                    onClick={() => window.open(url, '_blank')}
                                                                    onError={(e) => {
                                                                        // If image fails to load, replace with PDF icon
                                                                        const parent = e.currentTarget.parentElement
                                                                        if (parent) {
                                                                            e.currentTarget.style.display = 'none'
                                                                            const pdfDiv = document.createElement('div')
                                                                            pdfDiv.className = 'd-flex flex-column align-items-center justify-content-center rounded cursor-pointer'
                                                                            pdfDiv.style.cssText = 'width: 140px; height: 150px; border: 1px solid #eee; background-color: #f8f9fa;'
                                                                            pdfDiv.onclick = () => window.open(url, '_blank')
                                                                            pdfDiv.innerHTML = `
                                                            <i class="bi bi-file-earmark-pdf-fill" style="font-size: 50px; color: #dc3545;"></i>
                                                            <span class="mt-2 text-muted" style="font-size: 12px;">View PDF</span>
                                                        `
                                                                            parent.insertBefore(pdfDiv, e.currentTarget)
                                                                        }
                                                                    }}
                                                                />
                                                            )}

                                                        </div>
                                                    )
                                                })
                                            ) : (
                                                <span className="text-dark fw-semibold d-block fs-6">N/A</span>
                                            )}
                                        </div>
                                    </td>
                                    <td>
                                        <table className="table table-bordered table-sm m-0" style={{ borderCollapse: 'collapse', width: '100%', marginBottom: "10px", border: "1px solid #ddd" }}>
                                            <tbody>
                                                <tr>
                                                    <td className="fw-bold text-dark ps-2" style={{ width: '100px', border: '1px solid #ddd' }}>Name :</td>
                                                    <td className="text-gray-800 ps-2" style={{ border: '1px solid #ddd' }}>{user?.shippingInfo?.transporterName || 'N/A'}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold text-dark ps-2" style={{ border: '1px solid #ddd' }}>Mode :</td>
                                                    <td className="text-gray-800 ps-2" style={{ border: '1px solid #ddd' }}>{user?.shippingInfo?.mode || 'N/A'}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold text-dark ps-2" style={{ border: '1px solid #ddd' }}>Distance :</td>
                                                    <td className="text-gray-800 ps-2" style={{ border: '1px solid #ddd' }}>{user?.shippingInfo?.distance || 'N/A'}</td>
                                                </tr>
                                                <tr >
                                                    <td className="fw-bold text-dark ps-2" style={{ border: '1px solid #ddd' }}>Cost :</td>
                                                    <td className="text-gray-800 ps-2" style={{ border: '1px solid #ddd' }}>{user?.shippingInfo?.transportCost || 'N/A'}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>






                    <div className="table-responsive">
                        <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                            <thead>
                                <tr className="fw-bold text-muted bg-light">
                                    <th className="min-w-100px" style={{ backgroundColor: '#bfd7ed', color: 'black', paddingLeft: "10px" }}>Scope Certificate (Seller)</th>
                                    <th className="min-w-100px" style={{ backgroundColor: '#bfd7ed', color: 'black', paddingLeft: "10px" }}>Scope Certificate (Buyer)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        {(() => {
                                            const sellerDoc = user.document?.find((doc: any) => doc.docType === 'SUPPLIER_SCOPE_CERTIFICATE')
                                            if (sellerDoc?.docUrl) {
                                                const isPdf = sellerDoc.docUrl.toLowerCase().endsWith('.pdf') || sellerDoc.docUrl.toLowerCase().includes('.pdf')
                                                return (
                                                    <div className="text-center" style={{ position: 'relative' }}>
                                                        <div style={{ position: 'absolute', top: '5px', left: '5px', zIndex: 10 }}>
                                                            <input
                                                                type="checkbox"
                                                                checked={selectedDocs.some(d => d.docUrl === sellerDoc.docUrl)}
                                                                onChange={() => handleDocToggle(sellerDoc.docUrl, 'Scope Certificate (Seller)')}
                                                                style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                                                            />
                                                        </div>
                                                        {isPdf ? (
                                                            <div
                                                                className="d-flex flex-column align-items-center justify-content-center rounded cursor-pointer"
                                                                style={{
                                                                    width: '140px',
                                                                    height: '150px',
                                                                    border: '1px solid #eee',
                                                                    backgroundColor: '#f8f9fa'
                                                                }}
                                                                onClick={() => window.open(sellerDoc.docUrl, '_blank')}
                                                            >
                                                                <i className="bi bi-file-earmark-pdf-fill" style={{ fontSize: '50px', color: '#dc3545' }}></i>
                                                                <span className="mt-2 text-muted" style={{ fontSize: '12px' }}>View PDF</span>
                                                            </div>
                                                        ) : (
                                                            <img
                                                                src={sellerDoc.docUrl}
                                                                alt="Scope Certificate (Seller)"
                                                                className="h-150px w-150px object-cover rounded cursor-pointer"
                                                                style={{ maxWidth: '140px', border: '1px solid #eee' }}
                                                                onClick={() => window.open(sellerDoc.docUrl, '_blank')}
                                                                onError={(e) => {
                                                                    const parent = e.currentTarget.parentElement
                                                                    if (parent) {
                                                                        e.currentTarget.style.display = 'none'
                                                                        const pdfDiv = document.createElement('div')
                                                                        pdfDiv.className = 'd-flex flex-column align-items-center justify-content-center rounded cursor-pointer'
                                                                        pdfDiv.style.cssText = 'width: 140px; height: 150px; border: 1px solid #eee; background-color: #f8f9fa;'
                                                                        pdfDiv.onclick = () => window.open(sellerDoc.docUrl, '_blank')
                                                                        pdfDiv.innerHTML = `
                                                        <i class="bi bi-file-earmark-pdf-fill" style="font-size: 50px; color: #dc3545;"></i>
                                                        <span class="mt-2 text-muted" style="font-size: 12px;">View PDF</span>
                                                    `
                                                                        parent.insertBefore(pdfDiv, e.currentTarget)
                                                                    }
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                )
                                            }
                                            return <span className="text-dark fw-semibold d-block fs-6">N/A</span>
                                        })()}
                                    </td>
                                    <td>
                                        {(() => {
                                            const buyerDoc = user.document?.find((doc: any) => doc.docType === 'BUYER_SCOPE_CERTIFICATE')
                                            if (buyerDoc?.docUrl) {
                                                const isPdf = buyerDoc.docUrl.toLowerCase().endsWith('.pdf') || buyerDoc.docUrl.toLowerCase().includes('.pdf')
                                                return (
                                                    <div className="text-center" style={{ position: 'relative' }}>
                                                        <div style={{ position: 'absolute', top: '5px', left: '5px', zIndex: 10 }}>
                                                            <input
                                                                type="checkbox"
                                                                checked={selectedDocs.some(d => d.docUrl === buyerDoc.docUrl)}
                                                                onChange={() => handleDocToggle(buyerDoc.docUrl, 'Scope Certificate (Buyer)')}
                                                                style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                                                            />
                                                        </div>
                                                        {isPdf ? (
                                                            <div
                                                                className="d-flex flex-column align-items-center justify-content-center rounded cursor-pointer"
                                                                style={{
                                                                    width: '140px',
                                                                    height: '150px',
                                                                    border: '1px solid #eee',
                                                                    backgroundColor: '#f8f9fa'
                                                                }}
                                                                onClick={() => window.open(buyerDoc.docUrl, '_blank')}
                                                            >
                                                                <i className="bi bi-file-earmark-pdf-fill" style={{ fontSize: '50px', color: '#dc3545' }}></i>
                                                                <span className="mt-2 text-muted" style={{ fontSize: '12px' }}>View PDF</span>
                                                            </div>
                                                        ) : (
                                                            <img
                                                                src={buyerDoc.docUrl}
                                                                alt="Scope Certificate (Buyer)"
                                                                className="h-150px w-150px object-cover rounded cursor-pointer"
                                                                style={{ maxWidth: '140px', border: '1px solid #eee' }}
                                                                onClick={() => window.open(buyerDoc.docUrl, '_blank')}
                                                                onError={(e) => {
                                                                    const parent = e.currentTarget.parentElement
                                                                    if (parent) {
                                                                        e.currentTarget.style.display = 'none'
                                                                        const pdfDiv = document.createElement('div')
                                                                        pdfDiv.className = 'd-flex flex-column align-items-center justify-content-center rounded cursor-pointer'
                                                                        pdfDiv.style.cssText = 'width: 140px; height: 150px; border: 1px solid #eee; background-color: #f8f9fa;'
                                                                        pdfDiv.onclick = () => window.open(buyerDoc.docUrl, '_blank')
                                                                        pdfDiv.innerHTML = `
                                                        <i class="bi bi-file-earmark-pdf-fill" style="font-size: 50px; color: #dc3545;"></i>
                                                        <span class="mt-2 text-muted" style="font-size: 12px;">View PDF</span>
                                                    `
                                                                        parent.insertBefore(pdfDiv, e.currentTarget)
                                                                    }
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                )
                                            }
                                            return <span className="text-dark fw-semibold d-block fs-6">N/A</span>
                                        })()}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
































                    <WhatsappDocuments
                        selectedDocs={selectedDocs}
                        setSelectedDocs={setSelectedDocs}
                        orderId={user?.transactionId}
                    />
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={onClose}
                        >
                            Close
                        </button>
                    </div>
                </div>






            </div>
        </Modal>
    );
};